import { createContext, useContext, type ReactNode } from 'react';

export interface AuthContextValue {
  getAccessToken?: () => Promise<string | null>;
  instanceId?: string;
  isProduction?: boolean;
  evoOrganisationId?: string;
}

const AuthContext = createContext<AuthContextValue>({});

export function useAuth(): AuthContextValue {
  return useContext(AuthContext);
}

interface AuthProviderProps {
  getAccessToken?: () => Promise<string | null>;
  instanceId?: string;
  isProduction?: boolean;
  evoOrganisationId?: string;
  children: ReactNode;
}

export function AuthProvider({ getAccessToken, instanceId, isProduction, evoOrganisationId, children }: AuthProviderProps): React.ReactElement {
  return (
    <AuthContext.Provider value={{ getAccessToken, instanceId, isProduction, evoOrganisationId }}>
      {children}
    </AuthContext.Provider>
  );
}
